import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import log from 'utils/log';

/* eslint-disable no-await-in-loop */

/**
 * Extracts text from a PDF file.
 * @param file - The PDF file to extract text from.
 * @returns A promise that resolves with the extracted text.
 */
export function extractTextFromPdf(_x) {
  return _extractTextFromPdf.apply(this, arguments);
}
function _extractTextFromPdf() {
  _extractTextFromPdf = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
    var _yield$import, getDocument, GlobalWorkerOptions, reader;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 1;
          return import(/* webpackChunkName: "pdfjs" */'pdfjs-dist');
        case 1:
          _yield$import = _context2.sent;
          getDocument = _yield$import.getDocument;
          GlobalWorkerOptions = _yield$import.GlobalWorkerOptions;
          GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.4.168/build/pdf.worker.min.mjs';
          reader = new FileReader();
          return _context2.abrupt("return", new Promise(function (resolve, reject) {
            reader.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var typedArray, pdf, text, i, page, content;
              return _regeneratorRuntime.wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    typedArray = new Uint8Array(reader.result);
                    _context.next = 1;
                    return getDocument(typedArray).promise;
                  case 1:
                    pdf = _context.sent;
                    text = '';
                    i = 1;
                  case 2:
                    if (!(i <= pdf.numPages)) {
                      _context.next = 6;
                      break;
                    }
                    _context.next = 3;
                    return pdf.getPage(i);
                  case 3:
                    page = _context.sent;
                    _context.next = 4;
                    return page.getTextContent();
                  case 4:
                    content = _context.sent;
                    text += "".concat(content.items.map(function (item) {
                      return 'str' in item ? item.str : '';
                    }).join(' '), "\n\n");

                    // ChatGPT's maximum context length is 16385 tokens.
                    // If the text exceeds this length, we stop reading the PDF.
                    // Sending more would result in the following error from ChatGPT:
                    // This model's maximum context length is 16385 tokens. However, your messages resulted in 108456 tokens. Please reduce the length of the messages.
                    if (!(text.length > 40000)) {
                      _context.next = 5;
                      break;
                    }
                    log({
                      level: 'info',
                      message: "Text exceeds 40,000 characters. Stopping PDF extraction for ChatGPT. Text: ".concat(text.slice(0, 50))
                    });
                    return _context.abrupt("continue", 6);
                  case 5:
                    i++;
                    _context.next = 2;
                    break;
                  case 6:
                    resolve(text);
                  case 7:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            reader.onerror = function () {
              reject(reader.error);
            };
            reader.readAsArrayBuffer(file);
          }));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _extractTextFromPdf.apply(this, arguments);
}